// 4.19 A preview website claimed on its asset page (docs/specs/OUTREACH_ASSETS.md). The asset page sends the claimant
// to the app with ?claim=<asset id>; the id is kept in this browser (it survives the sign-in email opening a new tab)
// until their workspace exists, then the site is brought into their studio once (act import_claimed_site).

const KEY = "ogma.claim";
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Keeps a claim id from the address (?claim=...), if there is one. */
export function rememberClaim(search: string): void {
  const id = new URLSearchParams(search).get("claim");
  if (!id || !UUID.test(id)) return;
  try {
    localStorage.setItem(KEY, id.toLowerCase());
  } catch {
    // storage blocked: the claim simply isn't carried over
  }
}

/** The claim waiting to be brought in, or null. */
export function pendingClaim(): string | null {
  try {
    const v = localStorage.getItem(KEY);
    return v && UUID.test(v) ? v : null;
  } catch {
    return null;
  }
}

export function clearClaim(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // nothing to clear
  }
}
